module.exports = __webpack_public_path__ + "static/media/gsuite-green.0a8678ff.svg";